import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {navigator} from 'lit-element-router';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';

import store from '../../store';

import {
	selectSpcIsSatisfied,
	selectSpcSession,
	selectSpcConfiguration,
	selectBasicSpcAttributes,
	selectDetailSpcAttributes,
	selectBasicSpcAttributesSatisfied, selectRelux
} from '../../selectors';

@customElement('visual-specsheet')
export class VisualSpecsheet extends connect(store)(navigator(LitElement)) {

	static styles = css`
		:host {
			width: 100%;
			display: flex;
			flex-direction: column;
		}

		.specsheet {
			// background-color: #ffffff;
			display: flex;
			flex-direction: row;
			gap: 20px;
			width: 100%;
			height: calc(100vh - 100px);
			margin: 0;
			padding: 0;
			max-height: initial;
			box-sizing: border-box;
			overflow-y: scroll;
		}

		.pages {
			display: flex;
			flex-direction: column;
			container-type: inline-size;
			margin: 0 auto;
			flex-basis: 100%;
			overflow: initial;
			overflow-y: initial;
			padding-bottom: var(--very-large-padding);
		}
		language-switch {
			margin: auto;
		}
		.header {
			padding: var(--large-padding)0 var(--small-padding) 0;
			text-align: center;
			font: var(--font-downloads-title);
			color: var(--color-white);
		}
		.icon {
			display: inline-block;
			height: 16px;
			width: 16px;
			margin-right: 10px;
			color: #fff;
		}
	`;

	constructor() {
		super();
		this.closeTimout = null;
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.lang = state.status.lang;
		this.downloadStatus = state.download.status;
		this.downloadPngStatus = state.download.statusPng;

		this.relux = selectRelux(state);
		this.spcIsSatisfied = selectSpcIsSatisfied(state);
		this.session = selectSpcSession(state);
		this.spcConfiguration = selectSpcConfiguration(state);
		this.basicSpcAttributes = selectBasicSpcAttributes(state);
		this.isBasicSatisfied = selectBasicSpcAttributesSatisfied(state);
		this.detailSpcAttributes = selectDetailSpcAttributes(state);
	}

	connectedCallback() {
		super.connectedCallback();
	}


	render() {
		return html`
            <div class="specsheet">
                <div class="pages">
					<h1 class="header">${msg('Review Specsheet and Finalize Configuration')}</h1>
					<language-switch></language-switch>
					<shared-specsheet type="${this.specsheetType}"></shared-specsheet>
                </div>
				<finalize-cta></finalize-cta>
            </div>
        `;
	}
}
